import { useTranslation } from 'react-i18next'

import { EnvironmentOverlay as SharedEnvironmentOverlay } from '@percent/shared/environment-overlay'
import { environment } from '@percent/partner-dashboard/config'
import { environments } from '@percent/partner-dashboard/constants/environments'

/**
 * The shared overlay, in the partner dashboard's own words and translations. Its tab
 * scrolls away with the page, as it always has here.
 */
export function EnvironmentOverlay() {
  const { t } = useTranslation()

  return (
    <SharedEnvironmentOverlay
      environment={environment}
      label={
        environment === environments.SANDBOX
          ? t('typography.usingGoodstackSandbox')
          : t('typography.environment', { environment })
      }
      position="absolute"
    />
  )
}
